export enum ApartmentActiveKeyType {
  ActiveUnit = 'activeUnit',
  ActiveLevel = 'activeLevel',
  ActiveBlock = 'activeBlock',
}

export default {}
